<template>
    <li :status="status"><slot></slot></li>
</template>

<script>
export default {
    props: ["status"]
};
</script>
<style lang="scss" scoped>
@import "../../../assets/css/themes.scss";
li {
    @extend %second-background;
    @extend %primary-border;

    display: flex;
    width: 100%;
    border-left: 0px;
    font-size: 1.4rem;

    + li {
        margin-top: 20px;
    }

    &::before {
        display: inline-block;
        content: " ";
        width: 8px;
        height: 100%;
    }
    .dark &::before {
        // to display the ::before above the 1px borders
        margin: -1px;
        // 100% and balance the margin
        height: calc(100% + 2px);
    }

    &[status="in_progress"]::before {
        background-color: #ff7b15;
    }

    &[status="approved"]::before {
        background-color: #8ab400;
    }

    &[status="archived"]::before {
        background-color: #a3a3a3;
    }

    &[status="submitted"]::before {
        background-color: #41b4e8;
    }
}
</style>



// WEBPACK FOOTER //
// plano-banner.vue?304991b2